import { createSlice } from "@reduxjs/toolkit";

interface UserFormProps {
    UserFormData: any;
}

const initialState:UserFormProps = {
    UserFormData: {},
};


const UserForm = createSlice({
  name: "UserForm",
  initialState,
  reducers: {
    setUserFormData(state, action) {
      state.UserFormData = action.payload;
    },
  },
});

export default UserForm.reducer;

export const { setUserFormData } = UserForm.actions;
